import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@hey404/ui";
import { Input, type InputProps } from "./design-system";

/**
 * The platform `Input` with an eye toggle that reveals what was typed. Every
 * input prop passes through untouched, so call sites keep their own
 * validation and aria wiring.
 */
export function PasswordInput({
  className,
  ...props
}: Omit<InputProps, "type">) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;
  return (
    <span className="relative block">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={cn("pr-12", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        aria-pressed={visible}
        className="text-ink-soft hover:text-ink rounded-control absolute inset-y-0 right-0 grid w-12 cursor-pointer place-items-center"
      >
        <Icon size={18} aria-hidden="true" />
      </button>
    </span>
  );
}
